module.exports = __webpack_public_path__ + "static/media/cross-circle-red.01b9919b.svg";